// Comm_module.js version 2.00.20210623
var Crypto = require('crypto');

export default class CommModule {
	constructor(controller) {
		this.controller = controller;
		this.is_local = false;
		this.port_local = 52001;

		// web socket connection timeout
		this.ws_timeout = 3000;

		// Used when logging out so that websocket onclose do not reconnect
		this.is_logging_out = false;

		// Current websocket
		this.socket_status = 'disconnect';
		// Login status at app, default is 'logout'
		this.app_login_status = 'logout';
		// Login status at controller, default is 'logout'
		this.ctrl_login_status = 'logout';
		// Cloud connection status
		this.cloud_status = 'disconnect';

		// To track current websocket 
		this.current_ws_id = 0;

		// Track Websocket timeout and to kill when websocket onopen
		this.ws_timer = null;

		// To track if onError already called
		this.on_error_close = false;

		// To stop error checking if user logout
		this.is_stop_error_check = false;

		// To stop case 3/6 from looping
		this.is_looping_find_controller = false;
	}

	// receive commands from DATA LOGIC CORE
	send(packet) {
		// message to send to DSS
		let message = '';
		if (!this.is_local && packet.param1 == 'enc') {
			// Check if the param1 has enc when sending to SSC. SSC should not be enc
			packet.param1 = null;
		}

		if (this.controller.model != 'F10' && packet.command != 'msm') {
			//console.log('send: ' + JSON.stringify([packet.param1, packet.param2, [packet.command, packet.data]]));
		} else if (packet.command == 'msm') {
			//console.log('send: ' + JSON.stringify([packet.param1, packet.param2, ['msm', [this.controller.active_site, [packet.command, packet.data]]]]));
		}

		// For MSM to send commands when connecting to a site
		if (this.controller.model == 'F10' && packet.command != 'login' && packet.command != 'msm'
			&& this.controller.active_site != '') {

			if (packet.data != null && packet.data != undefined) {
				message = [packet.command, packet.data];
			} else {
				message = [packet.command];
			}

			if (packet.param1 == 'enc') {
				message = this.encrypt([this.controller.active_site, message]);
			} else {
				message = [this.controller.active_site, message];
			}

			message = ['msm', message];
			message = JSON.stringify([packet.param1, packet.param2, message]);
			//console.log('send: ' + JSON.stringify([packet.param1, packet.param2, ['msm', [this.controller.active_site, [packet.command, packet.data]]]]));
		} else {
			if (packet.data != null && packet.data != undefined) {
				// Encryption in local network
				if (packet.param1 == 'enc') {
					packet.data = this.encrypt(packet.data);
				}
				// Kaiwei 20210427 MSM
				//message = JSON.stringify([packet.param1, packet.param2, [packet.command, packet.data]]);
				message = [packet.command, packet.data];
			} else {
				// message without data
				//message = JSON.stringify([packet.param1, packet.param2, [packet.command]]);
				message = [packet.command];
			}

			message = JSON.stringify([packet.param1, packet.param2, message]);
		}

		// send command to SVM
		this.ws.send(message);
		if (packet.command == 'login') {
			this.loginTimeOut(6000);
		}
	}

	// receive information from SVM
	receive(data) {
		// Encrytption in local network
		if (data[0] == 'enc') {
			data[2][1] = JSON.parse(this.decrypt(data[2][1]))
		}
		//console.log('receive: ' + JSON.stringify(data))
		// update information to data logic
		this.controller.updateSVMData(data);
	}

	createWSS = () => {
		this.ws = null;
		//console.log('Connecting to ssc...');
		//console.log('this.controller.ssc_url = ' + this.controller.ssc_url);
		this.is_local = false;
		this.ws = new WebSocket(this.controller.ssc_url);
		this.current_ws_id++;
		this.websocketTimeout(this.ws_timeout, this.current_ws_id);
		this.socket_status = 'wait connection';
		this.cloud_status = 'disconnect';

		this.ws.onopen = this.onOpen;
		this.ws.onmessage = this.onMessage;
		this.ws.onerror = this.onError;
		this.ws.onclose = this.onClose;
	}

	createWS = () => {
		this.ws = null;
		//console.log('Connecting local...')
		this.is_local = true;
		this.socket_status = 'wait connection';
		try {
			let url = "ws://" + this.controller.ip_addr + ":" + this.port_local;
			//console.log('url = ' + url);
			this.ws = new WebSocket(url);
			this.current_ws_id++;
			this.websocketTimeout(this.ws_timeout, this.current_ws_id);

			this.ws.onopen = this.onOpen;
			this.ws.onmessage = this.onMessage;
			this.ws.onerror = this.onError;
			this.ws.onclose = this.onClose;
		} catch (e) {
			console.log(e.message);
		}
	}

	connectToSVM() {
		//console.log('this.controller.ssc_connect = ' + this.controller.ssc_connect)
		this.is_stop_error_check = false;
		// Check if controller connect flag for ssc is true
		// Kaiwei 20210520 Add check for is_mobile. Only connect via ssc when using mobile
		if (this.controller.ssc_connect && this.controller.receiver.is_mobile) {
			try {
				// First try to connect to SSC
				this.createWSS();
			} catch (e) {
				console.log(e.message);
			}
		} else {
			// if flag is false connect to local
			this.createWS();
		}
	}

	onOpen = (evt) => {
		//console.log('WS connected');
		// Kill websocket timeout function
		clearTimeout(this.ws_timer);

		// To stop case 6 from looping
		this.is_looping_find_controller = false;

		this.socket_status = 'connect';
		this.controller.receiver.rcvWSConnected();
		if (this.is_local) {
			// If local connection, Get sys_info 
			let packet = {}
			packet.param1 = null;
			packet.param2 = null;
			packet.command = 'sys_info';
			packet.data = this.controller.receiver.public_key;

			this.send(packet);
		} else {
			// If cloud connection send connect
			this.cloud_status = 'connect';
			let packet = {}
			packet.param1 = 'client';
			//packet.param2 = this.controller.hwkey;
			packet.param2 = this.controller.receiver.getHwKey(this.controller.mac_addr);
			packet.command = 'connect';
			packet.data = { "model": 'Reiri', "ver": '1.0' };

			this.send(packet);
		}
	}

	onMessage = (evt) => {
		this.receive(JSON.parse(evt.data));
	}

	onError = (evt) => {
		// Eg 1: From login page error connecting
		// Eg 2: After login has error
		// Eg 3: During reconnection websocket has error
		// Eg 4: websocket timeout
		// Eg 5: Controller disconnected
		console.log('Websocket onError')
		let ws_id = this.current_ws_id;
		setTimeout(() => {
			this.on_error_close = true;
			this.closeWS(ws_id);
		}, 1000)
	}

	// if connection is closed then move to login screen
	onClose = (evt) => {
		console.log('Websocket onclose');
		this.closeWS(this.current_ws_id);
	}

	closeWS = (ws_id) => {
		if (this.is_logging_out) {
			this.is_logging_out = false;
			this.ws = null;
		} else {
			if (this.is_stop_error_check) {
				return;
			}

			if (this.on_error_close) {
				this.on_error_close = false;
				//console.log('on_error_close this.current_ws_id = ' + this.current_ws_id )
				//console.log('on_error_close ws_id = ' + ws_id)

				if (this.current_ws_id != ws_id) {
					// If the ws is already closed, return
					return;
				}
			}

			this.controller.receiver.error({
				id: 506,
				severity: 'Severe',
				message: 'Websocket closed abnormally or unexpectedly.',
				controller_name: this.controller.name,
			})

			/*
			 * If ssc_connect is true
			 * Case 1: Connected to cloud but ws disconnected -> retry connection to cloud
			 * Case 18: Connected to cloud but ws disconnected (web version) -> go to login screen
			 * Case 2: Unable to connect to cloud after retry -> Try Local connection
			 * Case 3: Try Local connection but failed -> Find Controller in network
			 * Case 4: Timeout 2sec , if Find Controller failed -> Retry connection to cloud (case 2)
			 * *Case 14: Connected to Local but ws disconnected -> retry connection to Local
			 * *Case 15: Able to connect to cloud but controller not connected -> retry connection to Local
			 * 
			 * If ssc_connect is false
			 * Case 5: Connected to Local but ws disconnected -> retry connection to Local
			 * Case 16: Connected to Local but ws disconnected (web version) -> go to login screen
			 * Case 6: Retry failed -> Find Controller
			 * Case 7: Timeout 2sec, Find Controller failed -> Find Controller again
			 * 
			 * If Cloud connection can be connected but controller disconnected
			 * Case 8: Already logged in but controller disconnect -> Try Local connection
			 * Case 17: Already logged in but controller disconnect (web version) -> go to login screen
			 * 
			 * From Login Screen
			 * Case 9: Login Screen ssc can connect but controller disconnected -> Try Local connection
			 * Case 10: Login Screen ssc cannot connect -> Try Local connection
			 * Case 11: Login Screen (ssc) Local Connection cannot connect -> Find Controller
			 * Case 12: Timeout 2sec, Find Controller failed or Web version LAN connection failed -> Go to login Screen
			 * Case 13: Login Screen (Local conn) Local Connection cannot connect -> Find Controller
			 * 
			 */
			if (!this.controller.receiver.is_mobile) {
				// Case 0: If web app and ws connection failed, always go to login
				this.controller.receiver.onWSConnectionFailed();
				return;
			}

			if (this.controller.ssc_connect) {
				if (this.cloud_status == 'connect') {
					if (this.controller.receiver.is_mobile) {
						// Case 1
						//console.log('Case 1 Connect SSC...');
						this.socket_status = 'disconnect';
						this.cloud_status = 'disconnect';
						this.ctrl_login_status = 'logout';
						this.createWSS();
					} else {
						// Case 18
						//console.log('Case 18 Go to login screen');
						this.controller.receiver.onWSConnectionFailed();
					}
				} else if (this.socket_status == 'wait connection' && this.cloud_status == 'disconnect' && !this.is_local
					&& this.app_login_status == 'login') {
					// Case 2
					//console.log('Case 2 Connect Local...');
					this.socket_status = 'disconnect';
					this.ctrl_login_status = 'logout';
					this.createWS();
				} else if (this.socket_status == 'wait connection' && this.is_local && this.app_login_status == 'login') {
					if (!this.controller.receiver.is_mobile) {
						// Case 4
						//console.log('Case 4 Connect SSC...');
						this.createWSS();
					} else if (!this.is_looping_find_controller) {
						// Case 3
						//console.log('Case 3 Find Controller...');
						this.is_looping_find_controller = true;
						setTimeout(this.controller.receiver.commModuleControllerNotFound, 2000);
						this.controller.receiver.findController();
					}
				} else if (this.socket_status == 'wait connection' && this.cloud_status == 'disconnect' && !this.is_local
					&& this.app_login_status == 'logout') {
					// Case 10
					//console.log('Case 10 Connect Local...');
					this.socket_status = 'disconnect';
					this.createWS();
				} else if (this.socket_status == 'wait connection' && this.is_local && this.app_login_status == 'logout') {
					if (!this.controller.receiver.is_mobile) {
						// Case 12
						//console.log('Case 12 Go to login screen');
						this.controller.receiver.onWSConnectionFailed();
					} else {
						// Case 11
						//console.log('Case 11 Find Controller...');
						setTimeout(this.controller.receiver.commModuleControllerNotFound, 2000);
						this.controller.receiver.findController();
					}
				} else if (this.socket_status == 'connect' && this.is_local && this.app_login_status == 'login') {
					// Case 14
					//console.log('Case 14 Connect Local...');
					this.socket_status = 'disconnect';
					this.ctrl_login_status = 'logout';
					this.createWS();
				}
			} else {
				if (this.socket_status == 'connect') {
					if (this.controller.receiver.is_mobile) {
						// Case 5
						//console.log('Case 5 Connect Local...');
						this.socket_status = 'disconnect';
						this.ctrl_login_status = 'logout';
						this.createWS();
					} else {
						// Case 16
						//console.log('Case 16 Go to login screen');
						this.controller.receiver.onWSConnectionFailed();
					}
				} else if (this.socket_status == 'wait connection' && this.app_login_status == 'login') {
					if (!this.is_looping_find_controller) {
						if (this.controller.receiver.is_mobile) {
							// Case 6
							//console.log('Case 6 Find Controller...');
							this.is_looping_find_controller = true;
							setTimeout(this.controller.receiver.commModuleControllerNotFound, 2000);
							this.controller.receiver.findController();
						} else {
							// Case 12
							//console.log('Case 12 Go to login screen');
							this.controller.receiver.onWSConnectionFailed();
						}
					}
				} else if (this.socket_status == 'wait connection' && this.app_login_status == 'logout') {
					if (this.controller.receiver.is_mobile) {
						// Case 13
						//console.log('Case 13 Find Controller...');
						setTimeout(this.controller.receiver.commModuleControllerNotFound, 2000);
						this.controller.receiver.findController();
					} else {
						// Case 12
						//console.log('Case 12 Go to login screen');
						this.controller.receiver.onWSConnectionFailed();
					}
				}
			}
		}
	}

	// For decrypting incoming response when in local network
	decrypt = (data) => {
		let decipher = Crypto.createDecipheriv('aes-128-cbc', this.controller.receiver.common_key, this.controller.receiver.common_key);
		let decrypted = decipher.update(data, 'hex', 'utf8');
		decrypted += decipher.final('utf8');
		return decrypted;
	}

	// For encrypting outgoing requests when in local network
	encrypt = (data) => {
		let cipher = Crypto.createCipheriv('aes-128-cbc', this.controller.receiver.common_key, this.controller.receiver.common_key);
		let encrypted = cipher.update(JSON.stringify(data), 'utf8', 'hex');
		encrypted += cipher.final('hex');
		return encrypted;
	}

	logout() {
		// change login status to false
		// close web socket
		//console.log('logging out...')
		if (this.ws != null) {
			this.app_login_status = 'logout';
			this.is_logging_out = true;
			this.is_stop_error_check = true;
			// To stop case 3/6 from looping
			this.is_looping_find_controller = false;
			this.ws.close();
		}
	}

	// Timeout function in case websocket unable to connect
	// Checks if the websocket is connected after (ms) milliseconds, If not connected, throw error and close websocket
	websocketTimeout = (ms, ws_id) => {
		let comm_module = this;
		this.ws_timer = setTimeout(function () {
			if (ws_id == comm_module.current_ws_id) {
				if (comm_module.socket_status != 'connect' && comm_module.ws != null) {
					// When logout WS is null (i.e. dun throw error when logout)
					comm_module.controller.receiver.error({
						id: 601,
						severity: 'Fatal',
						message: 'Websocket Timeout.',
						controller_name: comm_module.controller.name,
					})
					comm_module.onError();
				}
			}
		}, ms);
	}

	// If ws has no error and after a number of ms still not logged in, throw error
	loginTimeOut(ms) {
		let comm_module = this;
		setTimeout(function () {
			if (comm_module.controller.is_logging_in && !comm_module.controller.is_logged_in && comm_module.ws != null) {
				// throw error
				comm_module.controller.receiver.error({
					id: 505,
					severity: 'Severe',
					message: 'Login Timeout.',
					controller_name: comm_module.controller.name,
				})
				comm_module.onError();
			}
		}, ms);
	}
}